import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { Spinner } from "@amzn/stencil-react-components/spinner";
import { Text } from "@amzn/stencil-react-components/text";
import ListModalButton, { LIST_MODAL_TYPE } from "common/components/ListModal/ListModalButton";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { getJobFamilyFromRule } from "common/helpers/lists-helper";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { Visibility } from "lib/models/list-models";
import { UserPermissions } from "lib/services";
import React, { FC, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useLists } from "../../../../hooks/ListsContext";
import { List } from "../List";
const ListsAdminPage: FC = () => {
  const history = useHistory();
  const { lists, loading, getLists } = useLists();

  const adminLists = UserPermissions.current.hasPermission(PERMISSIONS.AIFORME_ADMIN_LISTS);

  useEffect(() => {
    getLists({ includeItemDetails: true, visibility: Visibility.PUBLIC });
  }, [getLists]);

  if (!adminLists) {
    history.push("/");
    return null;
  }

  return (
    <Col>
      <PageMainContainer>
        <Container paddingTop={32} paddingBottom={32}>
          <Col gridGap={32}>
            <Row justifyContent="space-between">
              <Text fontSize="T400" fontWeight="bold" color="neutral90">
                {getString("lists.admin.title")}
              </Text>
              <ListModalButton
                type={LIST_MODAL_TYPE.ADMIN}
                jobFamilies={lists
                  .map((list) => getJobFamilyFromRule(list.evaluationRules))
                  .filter((jobFamily): jobFamily is string => jobFamily !== undefined)}
              />
            </Row>
            <Text fontSize="T200" color="neutral90">
              {getString("lists.adminDescription")}
            </Text>

            <Col gridGap="S300">
              {loading && <Spinner />}
              {!loading &&
                lists.map(
                  (list, index) =>
                    list.visibility == Visibility.PUBLIC && <List isAdmin key={`List-${index}`} {...list} />
                )}
              {!loading && lists.filter((list) => list.visibility == Visibility.PUBLIC).length == 0 && (
                <Text fontSize="T200" color="neutral90">
                  {getString("lists.noLists")}
                </Text>
              )}
            </Col>
          </Col>
        </Container>
      </PageMainContainer>
    </Col>
  );
};

export default ListsAdminPage;
